import { BaseEntity } from './base-entity';

/**
 * Role Interface
 */
export interface Role extends BaseEntity {
  name: string;
  accessList: Access;
}

export interface Access {
  read: boolean;
  edit: boolean;
  add: boolean;
  lock: boolean;
  unlock: boolean;
  publish: boolean;
  import: boolean;
  export: boolean;
  remove: boolean;
}

export interface RoleAccessKey {
  key: keyof Access; // Ensure curr.key is one of the keys in ToolAccess
  name: string;
}

export function mergeAccessList(accessList: Access[]): Access {
  return accessList.reduce(
    (mergedAccess, currentAccess) => ({
      read: mergedAccess.read || currentAccess.read,
      edit: mergedAccess.edit || currentAccess.edit,
      add: mergedAccess.add || currentAccess.add,
      lock: mergedAccess.lock || currentAccess.lock,
      unlock: mergedAccess.unlock || currentAccess.unlock,
      publish: mergedAccess.publish || currentAccess.publish,
      import: mergedAccess.import || currentAccess.import,
      export: mergedAccess.export || currentAccess.export,
      remove: mergedAccess.remove || currentAccess.remove,
    }),
    {
      read: false,
      edit: false,
      add: false,
      lock: false,
      unlock: false,
      publish: false,
      import: false,
      export: false,
      remove: false,
    } as Access // Default object with all permissions set to false
  );
}

/**
 * TODO:
 * specify access-logic
 */
//export interface AccessList {
//  id: number;
//  name: string;
//  toolAccess: ToolAccess[];
//  indicatorCategoriesAccess: IndicatorCategoriesAccess[];
//  bookmarkCategoriesAccess: BookmarkCategoriesAccess[];
//  poiLayerTypesAccess: PoiLayerTypesAccess[];
//  dataLayerTypesAccess: DataLayerTypesAccess[];
//}
///**
// * TODO:
// * specify
// * no db needed
// * - add service/ configuration
// */
//export interface ToolAccess {
//  name: string;
//  read: boolean;
//  write: boolean;
//}
//
//export interface IndicatorCategoriesAccess {
//  ids: string[];
//  read: boolean;
//  write: boolean;
//}
//
//export interface BookmarkCategoriesAccess {
//  ids: string[];
//  read: boolean;
//  write: boolean;
//}
//
//export interface PoiLayerTypesAccess {
//  ids: string[];
//  read: boolean;
//  write: boolean;
//}
//
//export interface DataLayerTypesAccess {
//  ids: string[];
//  read: boolean;
//  write: boolean;
//}
//
